<template>
  <div class="header">
    <div class="headerbg">
      <div class="headerM">
        <img src="/static/logo.png" style="float:left;width: 40px;margin-top: 2px;">
        <a class="logo" href="/"><span>{{config.schooName}}</span>智慧校园信息服务平台</a>
        <p style="padding-left: 68p;font-size:12px;font-weight:200;margin-left: 65px;">Smart School information service platform</p>
      </div>
      <div class="navleft">
        <!-- <a href="/" name="login" class="on">首页</a> -->
        <!-- <router-link :to="{name:'App'}" class="more">应用中心</router-link> -->
        <!-- <router-link :to="{name:'ArticleList'}" class="more">平台公告</router-link> -->
        <!-- <router-link :to="{name:'smartschoollist'}" class="more">智慧校园</router-link> -->

        <!-- <a href="javascript:void(0)">智慧校园</a> -->
      </div>
      <!-- <div class="navright">
        <a href="javascript:void(0)" class="wx" >
          微信公众号
          <em class="Qrcode">
            <img src="/static/qrcode.jpg" alt width="240px">
            <p>扫一扫，进入微信公众号系统</p>
          </em>
        </a>
      </div> -->
    </div>

    <div class="headerYY"></div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      config: window.config
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 70px !important;
  background: #ffffff;
  position: relative;
  z-index: 1600;
  // border-bottom: 1px solid #1f8dc1;
}
.headerM {
  padding: 10px 0;
  margin: 0 auto;
  width: 80%;
  .logo {
    // float: left;
    margin: 5px 0 0;
    font-size: 23px;
    font-weight: 350;
    letter-spacing: 3px;
    color: #636363;
    padding: 6px 0 6px 15px;
    text-decoration: none;
  }
}
.navleft {
  float: left;
  padding: 20px 0 0 20px;
  margin: 0 10px 0 0;
}
.navleft a {
  float: left;
  color: #636363;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 0 5px;
  padding: 0 18px;
  border-radius: 5px;
  font-weight: 300;
}
.navleft a:hover {
  text-decoration: none;
  background: #00b2ee;
  color: #fff;
}
.navleft a.on {
  color: #000000;
}

.navright {
  float: right;
  padding: 20px 0 0 20px;
  margin: 0 10px 0 0;
}
.navright a {
  float: left;
  color: #67c23a;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 0 5px;
  padding: 0 18px;
  border: 1px solid #67c23a;
  border-radius: 5px;
}
.navright a:hover {
  color: #000000;
  text-decoration: none;
  background: #b0ff88;
}
.navright a.on {
  color: #000000;
}

.navright .wx {
  position: relative;
}
.navright .wx .Qrcode {
  display: none;
  position: absolute;
  top: 50px;
  text-align: center;
  width: 282px;
  padding-top: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
  height: 290px;
  left: 50%;
  margin-left: -210px;
  color: #222;
  z-index: 999;
}
.navright .wx:hover .Qrcode {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue